import './card-list-gallery.scss';

/**
 * version    1.0
 * class      <type> (CardListGallery)
 * classdesc
 */
export class CardListGallery {}
